import FactorsList from '../../../components/factor-list/FactorsList';
import BaseForgeCustomizer from '../../base-forge';
import { isAnetUser } from '../../../utils/user-utils';
export default class ChallengeFactorCustomizer extends BaseForgeCustomizer {

  private isAnetUser: boolean = isAnetUser();
  displayFooterText = this.isAnetUser;


  async shouldCustomize() {
    return this.context.formName === 'select-authenticator-authenticate';
  }

  protected forgifyController() {
    super.forgifyController();
    this.forgifyFactors();
  }

  headerDescription = jQueryCourage('.o-form-explain').text();

  forgifyFactors() {
    const factors = jQueryCourage('.authenticator-verify-list');
    const forgeComponent = <FactorsList challenge oktaFactorsList={factors.find('.authenticator-row')}/>;
    this.renderForgeAndHideOktaComponent({ id: 'authenticator-verify-list', oktaComponent: factors, forgeComponent });
  }
}
